export default __webpack_public_path__ + "static/media/linkedinRosa.b33d0019.svg";